export default "__VITE_ASSET__X849vBX5__"